import getCountryByCode from './getCountryByCode';

const formatAddressMultiLine = ({
  city,
  country,
  street,
  streetAddition,
  zip,
}: {
  street: string;
  streetAddition?: string;
  city: string;
  zip: string;
  country?: string;
}) => {
  const countryName = country ? `, ${getCountryByCode(country)}` : '';
  return [street, streetAddition, `${zip} ${city}${countryName}`]
    .filter((value) => value)
    .join('\n')
    .trim();
};

export default formatAddressMultiLine;
